import { WorkOrderModuleCategoriesSettings } from 'lane-shared/domains/workOrder';

export type DropdownOption = { label: string; value: string };

export const ALL_ISSUE_TYPES_VALUE = 'ALL_ISSUE_TYPES';
export const NONE_ISSUE_TYPE_VALUE = 'NONE';

export function buildCategoryItems(
  categories: WorkOrderModuleCategoriesSettings[]
): DropdownOption[] {
  return categories
    .filter(c => (c.firendlyName ?? '').trim() !== '')
    .map(c => ({ label: c.firendlyName, value: c.firendlyName }));
}

export function findSelectedCategory(
  categories: WorkOrderModuleCategoriesSettings[],
  categoryValue: string | null
): WorkOrderModuleCategoriesSettings | undefined {
  return categories.find(c => c.firendlyName === categoryValue);
}

export function buildIssueTypeItems(
  selectedCategory: WorkOrderModuleCategoriesSettings | undefined,
  t: (key: string) => string
): DropdownOption[] {
  if (!selectedCategory) {
    return [];
  }

  const issues = (selectedCategory.issues ?? []).filter(
    i => (i ?? '').trim() !== ''
  );

  return [
    {
      label: t(
        'web.admin.serviceRequest.settings.coverageHours.create.allIssueTypes'
      ),
      value: ALL_ISSUE_TYPES_VALUE,
    },
    {
      label: t(
        'web.admin.serviceRequest.settings.coverageHours.create.none'
      ),
      value: NONE_ISSUE_TYPE_VALUE,
    },
    ...issues.map(issue => ({ label: issue, value: issue })),
  ];
}
